import { ReactElement } from 'react'
import { find } from 'lodash-es'
import { MenuItem, Select, SelectChangeEvent, SxProps, Typography } from '@mui/material'
import { Box } from '@ui/structure'

export interface SelectLabeledOption {
  value: string | number
  label: string
  disabled?: boolean
}

export interface SelectLabeledProps {
  label: string
  value: string | number
  onChange: (event: SelectChangeEvent<string | number>) => void
  options: SelectLabeledOption[]
  disabled?: boolean
  selectWidth?: number
  'data-cy'?: string
  sx?: SxProps
  boxSx?: SxProps
}

const SelectLabeled = ({
  label,
  value,
  onChange,
  options,
  disabled,
  selectWidth = 225,
  'data-cy': dataCy,
  sx,
  boxSx,
}: SelectLabeledProps): ReactElement => {
  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" sx={boxSx}>
      <Typography sx={{ py: 0, px: 1, flexShrink: 0, ...sx }}>{label}</Typography>
      <Select
        size="small"
        value={value}
        onChange={onChange}
        disabled={disabled}
        displayEmpty
        sx={{ width: selectWidth, flexShrink: 0 }}
        data-cy={dataCy ? `${dataCy}-dropdown` : undefined}
        renderValue={selected => find(options, ['value', selected])?.label}
      >
        {options.map(
          ({ value: optionValue, label: optionLabel, disabled: optionDisabled }, index) => (
            <MenuItem
              key={String(optionValue)}
              value={optionValue}
              disabled={optionDisabled}
              data-cy={dataCy ? `${dataCy}-item-${index}` : undefined}
            >
              {optionLabel}
            </MenuItem>
          ),
        )}
      </Select>
    </Box>
  )
}

export default SelectLabeled
